import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emrsidebar',
  templateUrl: './emrsidebar.component.html',
  styleUrls: ['./emrsidebar.component.css']
})
export class EmrsidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emrsidebar/emrsidebar.component.ts